// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TqPNLlJcvt {
  width: 369px;
  padding: 4px;
  box-shadow: 0 0 2px 2px rgba(0, 0, 0, 0.06);
  float: left;
  background: #fff;
}
.TqPNLlJcvt h4 {
  line-height: 3em;
}
.TqPNLlJcvt .z9TTF5VaH1 {
  float: left;
  width: 100%;
}
.TqPNLlJcvt ._2w4s4d7QkP {
  height: 40px;
  width: 60px;
  float: left;
  display: inline-block;
  min-height: 0;
  border-radius: 0;
  margin-bottom: 0;
  position: relative;
}
.TqPNLlJcvt ._2w4s4d7QkP:hover {
  cursor: pointer;
}
.TqPNLlJcvt ._2w4s4d7QkP:hover:after {
  position: absolute;
  content: "";
  z-index: 10;
  height: 40px;
  width: 60px;
  top: 0;
  left: 0;
  background: rgba(255, 255, 255, 0.3);
}
.oWbD2MTuwY .jwzyNiVDsa:focus {
  outline: none;
}
.oWbD2MTuwY .jwzyNiVDsa.HzqB4HmVHP.JuiO0SKm9S {
  background: #375A88;
}
.oWbD2MTuwY .jwzyNiVDsa.HzqB4HmVHP.JuiO0SKm9S span {
  color: #fff;
}
.oWbD2MTuwY .JuiO0SKm9S {
  background: #F5F4F9;
  border: 1px solid rgba(0, 0, 0, 0.06);
  color: rgba(0, 0, 0, 0.2);
}
.oWbD2MTuwY .JuiO0SKm9S:hover {
  background: #4F5157;
  color: #fff;
  border: 1px solid rgba(0, 0, 0, 0.06);
}
.oWbD2MTuwY input {
  height: 38px;
  min-width: 220px;
}
._2w4s4d7QkP.Rske93cKdE {
  background: #410102;
}
._2w4s4d7QkP.It3vHWmm4X {
  background: #911318;
}
._2w4s4d7QkP.sNXq4OzwR3 {
  background: #D8293B;
}
._2w4s4d7QkP.eDCMDJKsqI {
  background: #F2373C;
}
._2w4s4d7QkP.SdOWY0CLar {
  background: #FC4448;
}
._2w4s4d7QkP.hZqTNzAie0 {
  background: #ED535E;
}
._2w4s4d7QkP.R_FwGe20RK {
  background: #E34926;
}
._2w4s4d7QkP.YfTNvgaqJF {
  background: #FC562B;
}
._2w4s4d7QkP.gw7OXe2Rye {
  background: #FC6722;
}
._2w4s4d7QkP.QeO8P8AAqk {
  background: #FD7F24;
}
._2w4s4d7QkP.HdencRd3nc {
  background: #FD8D26;
}
._2w4s4d7QkP.oK3iLnM2cD {
  background: #EC9C3E;
}
._2w4s4d7QkP.wypXN9Y8gs {
  background: #0e673a;
}
._2w4s4d7QkP.Id3hHWu4Qp {
  background: #208740;
}
._2w4s4d7QkP.I9_z7rhSDx {
  background: #239718;
}
._2w4s4d7QkP.YmgV_bRkj3 {
  background: #55A84D;
}
._2w4s4d7QkP.Udrh5BZDwd {
  background: #4BBE5A;
}
._2w4s4d7QkP.lP0XvhEAOc {
  background: #0CCA6A;
}
._2w4s4d7QkP.mwOCp6ElcY {
  background: #0A3C64;
}
._2w4s4d7QkP.OXmTeamBU3 {
  background: #0d487a;
}
._2w4s4d7QkP.uqocZ_Q80_ {
  background: #10538d;
}
._2w4s4d7QkP.Yp26VTOxNY {
  background: #115A99;
}
._2w4s4d7QkP.qkaJjNynOO {
  background: #3387E2;
}
._2w4s4d7QkP.rfWh10lkgi {
  background: #1BA9CF;
}
._2w4s4d7QkP.I5mqiJ2aJZ {
  background: #d27c02;
}
._2w4s4d7QkP.k0muDCzISm {
  background: #fb9402;
}
._2w4s4d7QkP.a5JW9uPg0w {
  background: #FD9B30;
}
._2w4s4d7QkP.HIpvW7JyZ1 {
  background: #FDBE2D;
}
._2w4s4d7QkP.qqsFgjHVWb {
  background: #FED831;
}
._2w4s4d7QkP.fMW29ZqROg {
  background: #FFFD38;
}
._2w4s4d7QkP.pu7J6btWfr {
  background: #2D215C;
}
._2w4s4d7QkP.yfC0zBSRFL {
  background: #483C83;
}
._2w4s4d7QkP.fzfgCfTcHJ {
  background: #58518d;
}
._2w4s4d7QkP.d9nsrbykBA {
  background: #7068A9;
}
._2w4s4d7QkP.z61ENK1VEl {
  background: #7f78b2;
}
._2w4s4d7QkP.QeVsJQ0ym4 {
  background: #8f88bc;
}
._2w4s4d7QkP.ZkDWbxd5KZ {
  background: #000;
}
._2w4s4d7QkP.ewnV_rWxhR {
  background: #282626;
}
._2w4s4d7QkP.vw4_SzJV8w {
  background: #242222;
}
._2w4s4d7QkP.U62vzXgldF {
  background: #353838;
}
._2w4s4d7QkP.siN6j2vo5p {
  background: #666;
}
._2w4s4d7QkP.Exkgth_8ja {
  background: #999;
}
.HPXAun_m1K {
  background: none;
  margin-top: 120px;
  position: relative;
  margin-left: 10px;
}
.HPXAun_m1K .XtWrRFnw_o {
  display: none;
}
.YccAeIA6Bo {
  display: flex;
  flex-direction: column;
  height: 100%;
  font-size: 11px;
}
.YccAeIA6Bo .c71YXgBpmc {
  display: flex;
}
.YccAeIA6Bo .MxXuXzkUol {
  flex: 1.3;
}
.YccAeIA6Bo .MxXuXzkUol .tippy-content {
  text-transform: initial;
}
.YccAeIA6Bo .vgl3hwpfBb {
  flex: 2.6;
  margin-right: 22px;
}
.YccAeIA6Bo .MxXuXzkUol .BKHsoFVQCf {
  display: flex;
  align-items: center;
  margin-bottom: 4px;
}
.YccAeIA6Bo .MxXuXzkUol .BKHsoFVQCf .MvOtWN7cFZ {
  font-size: 11px;
  font-weight: bold;
  margin-right: 8px;
  text-transform: uppercase;
}
.YccAeIA6Bo .MxXuXzkUol .BKHsoFVQCf .UBNJIOxook {
  cursor: pointer;
  font-size: 12px;
}
.YccAeIA6Bo .MxXuXzkUol .BKHsoFVQCf .overview-root__tooltip {
  line-height: 18px;
  padding: 8px;
}
.YccAeIA6Bo .MxXuXzkUol .xS76oJS03U {
  background: none;
}
.YccAeIA6Bo .Bwo6rBtBAB {
  min-height: 62px;
  margin: 0;
  resize: none;
}
.YccAeIA6Bo .PLXJRsj5XZ {
  border-color: #DB383B;
}
.YccAeIA6Bo .MxXuXzkUol .o_5NSflMq4 {
  left: 4px;
  position: relative;
}
.YccAeIA6Bo .c71YXgBpmc + .c71YXgBpmc {
  margin-top: 18px;
}
.YccAeIA6Bo .epwsIZsNFh {
  display: flex;
  margin-top: 18px;
}
.YccAeIA6Bo .epwsIZsNFh .eycsno5jhJ {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.YccAeIA6Bo .epwsIZsNFh .eycsno5jhJ .EqXzi4LkKq {
  display: flex;
  line-height: 15px;
}
.YccAeIA6Bo .epwsIZsNFh .eycsno5jhJ .EqXzi4LkKq .lGDaobscAA {
  min-width: 72px;
  text-align: center;
  border-bottom: 1px solid #707070;
  cursor: pointer;
}
.YccAeIA6Bo .epwsIZsNFh .eycsno5jhJ .EqXzi4LkKq .Hzt1uLTfJT {
  font-size: 11px;
}
.YccAeIA6Bo .epwsIZsNFh .eycsno5jhJ .EqXzi4LkKq .lGDaobscAA .tMUvZSXM0c {
  line-height: 15px;
  margin-left: 6px;
}
.YccAeIA6Bo .epwsIZsNFh .eycsno5jhJ .EqXzi4LkKq .cLcEPOd_NH {
  margin-left: 20px;
}
.YccAeIA6Bo .stage-row .MuiAccordionSummary-root {
  display: flex;
  padding: 0px 16px;
}
.pvo0Wu2Itc {
  height: 300px;
}
.suJWbIG9Ly,
.suJWbIG9Ly {
  position: absolute;
  min-width: 216px;
  left: -120px;
}
.ZvnnZqqKT8 {
  display: flex;
  align-items: center;
  min-height: 31px;
  background: white;
  border-bottom: 1px solid #e5e5e5;
}
.ZvnnZqqKT8 .eGQ7uZXXI4 {
  margin-left: 16px;
  font-size: 12px;
}
.ZvnnZqqKT8 .CkZo292k1I {
  width: 100%;
  margin: 0;
}
.ZvnnZqqKT8 .M80_j7b3Ua,
.ZvnnZqqKT8 .M80_j7b3Ua {
  font-size: 11px !important;
  opacity: 0.42;
}
.Rejb4fZtCg {
  margin: 0 !important;
  background: white;
  max-height: 268px;
}
.Rejb4fZtCg .menu-list {
  background-color: white;
  padding: 0;
  max-height: 268px;
}
.Rejb4fZtCg .menu-list > div {
  max-height: 268px !important;
  overflow: hidden;
}
.Rejb4fZtCg .menu-list > div > div {
  max-height: 268px !important;
}
.Rejb4fZtCg .menu-list > div > div > div:first-child {
  max-height: 286px !important;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"color-picker": `TqPNLlJcvt`,
	"color-row": `z9TTF5VaH1`,
	"color-tile": `_2w4s4d7QkP`,
	"picker-component": `oWbD2MTuwY`,
	"picker-element": `jwzyNiVDsa`,
	"active": `HzqB4HmVHP`,
	"btn": `JuiO0SKm9S`,
	"red-1": `Rske93cKdE`,
	"red-2": `It3vHWmm4X`,
	"red-3": `sNXq4OzwR3`,
	"red-4": `eDCMDJKsqI`,
	"red-5": `SdOWY0CLar`,
	"red-6": `hZqTNzAie0`,
	"orange-1": `R_FwGe20RK`,
	"orange-2": `YfTNvgaqJF`,
	"orange-3": `gw7OXe2Rye`,
	"orange-4": `QeO8P8AAqk`,
	"orange-5": `HdencRd3nc`,
	"orange-6": `oK3iLnM2cD`,
	"green-1": `wypXN9Y8gs`,
	"green-2": `Id3hHWu4Qp`,
	"green-3": `I9_z7rhSDx`,
	"green-4": `YmgV_bRkj3`,
	"green-5": `Udrh5BZDwd`,
	"green-6": `lP0XvhEAOc`,
	"blue-1": `mwOCp6ElcY`,
	"blue-2": `OXmTeamBU3`,
	"blue-3": `uqocZ_Q80_`,
	"blue-4": `Yp26VTOxNY`,
	"blue-5": `qkaJjNynOO`,
	"blue-6": `rfWh10lkgi`,
	"yellow-1": `I5mqiJ2aJZ`,
	"yellow-2": `k0muDCzISm`,
	"yellow-3": `a5JW9uPg0w`,
	"yellow-4": `HIpvW7JyZ1`,
	"yellow-5": `qqsFgjHVWb`,
	"yellow-6": `fMW29ZqROg`,
	"purple-1": `pu7J6btWfr`,
	"purple-2": `yfC0zBSRFL`,
	"purple-3": `fzfgCfTcHJ`,
	"purple-4": `d9nsrbykBA`,
	"purple-5": `z61ENK1VEl`,
	"purple-6": `QeVsJQ0ym4`,
	"black-1": `ZkDWbxd5KZ`,
	"black-2": `ewnV_rWxhR`,
	"black-3": `vw4_SzJV8w`,
	"black-4": `U62vzXgldF`,
	"black-5": `siN6j2vo5p`,
	"black-6": `Exkgth_8ja`,
	"picker-theme": `HPXAun_m1K`,
	"arrow-regular": `XtWrRFnw_o`,
	"overview-root": `YccAeIA6Bo`,
	"inputs-row": `c71YXgBpmc`,
	"inputs-row__input": `MxXuXzkUol`,
	"inputs-row__input--title": `vgl3hwpfBb`,
	"row-label__section": `BKHsoFVQCf`,
	"row-label__text": `MvOtWN7cFZ`,
	"row-label__icon": `UBNJIOxook`,
	"row-label__selectContainer": `xS76oJS03U`,
	"inputs-row__input--instruction": `Bwo6rBtBAB`,
	"inputs-row__input--instruction--error": `PLXJRsj5XZ`,
	"round-type__menu-container": `o_5NSflMq4`,
	"stage-row": `epwsIZsNFh`,
	"row-label__stage": `eycsno5jhJ`,
	"label-stage__item": `EqXzi4LkKq`,
	"stage-item__section": `lGDaobscAA`,
	"stage-item__section--icon": `Hzt1uLTfJT`,
	"stage-item__text": `tMUvZSXM0c`,
	"add-stage": `cLcEPOd_NH`,
	"available-templates__root": `pvo0Wu2Itc`,
	"available-templates__menuCtn": `suJWbIG9Ly`,
	"available-templates-select__control": `ZvnnZqqKT8`,
	"available-templates-select__searchIcon": `eGQ7uZXXI4`,
	"available-templates-select__search": `CkZo292k1I`,
	"available-templates-select__placeholder": `M80_j7b3Ua`,
	"available-templates-select__menu": `Rejb4fZtCg`
};
export default ___CSS_LOADER_EXPORT___;
